import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import "./SubNavbar.css";

function SubNavbar({ marginTop = "72px" }) {
  const auth = useAuth();
  const navigate = useNavigate();

  if (!auth || !auth.currentUser) {
    return null;
  }

  const userName =
    auth.riderData?.first_name && auth.riderData?.last_name
      ? `${auth.riderData.first_name} ${auth.riderData.last_name}`
      : auth.riderData?.first_name ||
        auth.currentUser?.displayName ||
        auth.currentUser?.email?.split("@")[0] ||
        "Rider";

  return (
    <div className="sub-navbar" style={{ marginTop }}>
      <div className="sub-navbar-container">
        <div className="sub-navbar-welcome">
          <span className="sub-navbar-greeting">
            Welcome back, <strong className="sub-navbar-name">{userName}</strong>
          </span>
          <span className="sub-navbar-wave">👋</span>
        </div>

        <div className="sub-navbar-actions">
          <button
            className="sub-navbar-btn activity-btn"
            onClick={() => navigate("/ride-history")}
            title="View recent activities"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>Recent Activities</span>
          </button>

          <button
            className="sub-navbar-btn account-btn"
            onClick={() => window.open("/settings", "_blank")}
            title="View account settings"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>Account</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubNavbar;
